module.exports = __webpack_public_path__ + "WillowTreeTavern.webp?eacfa1f9788f4f36a49a7d82bfffcf25";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/WillowTreeTavern.webp
// module id = 183
// module chunks = 0